import { motion } from "framer-motion";
import useModal from "../../../hooks/useModal";
import Modal from "../../Modal/index";
import ModalContainer from "../../Modal/ModalContainer";
import "./styles.css";
import { BiPrinter } from "react-icons/bi";
import { IoCheckmark } from "react-icons/io5";
import { formatArabicDate } from "../../../utils/dateformat";
import axios from "axios";
import { useState } from "react";

function OrderHeader({ id, order }) {
  const { modalOpen, close, open } = useModal();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  const handleConfirm = () => {
    setLoading(true); 
    
    axios
      .put(
        process.env.REACT_APP_API_URL+"mandoub/orders?id="+order._id, 
        {}, 
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authMandoub'))?.token}`,
          },
        }
      )
      .then((response) => {
        console.log("Order updated successfully:", response.data);
        setSuccess(true);
        close(); 
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error updating order:", error);
        setLoading(false);
      });
  };

  return (
    <div>
      <ModalContainer>
        {modalOpen && (
          <Modal
            modalOpen={modalOpen}
            text={"هل أنت متأكد؟ هذه العملية لا يمكن التراجع عنها"}
            type={"dropIn"}
            handleConfirm={handleConfirm}
            handleClose={close}
            loading={loading}
          />
        )}
      </ModalContainer>
      <div className="df jc-sb header-details">
        <span className="text df">
          <span className="title">الطلب#{id}</span>
          <span className="text text-xs">{formatArabicDate(order.createdAt)}</span>
          {order.paymentStatus === "Paid" && <div className="paid-status">مدفوع</div>}
          {order.paymentStatus === "Unpaid" && <div className="paid-status">غير مدفوع</div>}
        </span>
        <div className="df header-btns">
          <motion.div
            className="details-btn df"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handlePrint}
          >
            طباعة
            <BiPrinter />
          </motion.div>
          {order.status !==  "Delivered" && !success &&<motion.div
            className="details-btn df"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={open}
          >
            وضع علامة كتم التسليم
            <IoCheckmark />
          </motion.div>}
        </div>
      </div>
    </div>
  );
}

export default OrderHeader;